module.exports = __webpack_public_path__ + "img/rpg_2.c2d902ea.jpeg";